import { Outlet } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';
import { Sidebar } from './components/Sidebar/Sidebar';
import { useState } from 'react';

const drawerWidth = 240;

export const SidebarLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Sidebar 
        mobileOpen={mobileOpen} 
        handleDrawerToggle={handleDrawerToggle} 
        drawerWidth={drawerWidth} 
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        //   ml: { sm: `${drawerWidth}px` }
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};